import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../../components/Layout';
import { Button } from '../../../components/ui/Button';
import { Card, CardContent } from '../../../components/ui/Card';
import { FileText } from 'lucide-react';

/**
 * Placeholder for creating RAMS linked to a job.
 * Shows empty state until the Jobs module exists.
 * Route: /tenant/jobs/:jobId/rams/new
 */
export default function JobRamsNew() {
  const { jobId } = useParams();
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
          <CardContent className="pt-8 pb-8 px-8 text-center">
            <div className="flex justify-center mb-4">
              <div className="rounded-full bg-gray-100 dark:bg-gray-700 p-4">
                <FileText className="h-10 w-10 text-gray-500 dark:text-gray-400" />
              </div>
            </div>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              New RAMS for job
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
              Creating RAMS linked to a job will be available when the Jobs module is released.
              You can create standalone RAMS from Tools in the meantime.
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-500 mb-6">
              Job ID: {jobId || '—'}
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              <Button
                variant="default"
                size="sm"
                onClick={() => navigate('/tenant/tools/rams/new')}
              >
                Create standalone RAMS
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate('/tenant/tools/rams')}
              >
                Back to RAMS list
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate('/tenant/dashboard')}
              >
                Dashboard
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
